let labels = {
  AccountType: 'Account Type',
  StoreType: 'Store Type',
  Territory: 'Territory',
  Region: 'Region'
};

export default labels;
